module.exports = __webpack_public_path__ + "img/musicIcon.94857a5e.svg";